import { catchError, tap, race } from 'rxjs/operators';
import { Browser } from './browser';
import { StorageFactory } from './storage';
import { TokenLoader, TokenStorage, UrlTokenParser } from './token';
import { ClientSecurityApi, TokenRenewer, UserActivity } from './tokenRenew';
import { RedirectLoginStrategy } from './login';
import { SessionManager } from './session';

const browser = new Browser();
const storageFactory = new StorageFactory(browser);
const storage = storageFactory.getStorage();
const tokenStorage = new TokenStorage(storage);
const urlTokenParser = new UrlTokenParser(browser);
const tokenLoader = new TokenLoader(tokenStorage, urlTokenParser);
const clientSecurityApi = new ClientSecurityApi();
const userActivity = new UserActivity(browser);
const loginStrategy = new RedirectLoginStrategy(browser);
const sessionManager = new SessionManager();
const tokenRenewer = new TokenRenewer(sessionManager, userActivity, clientSecurityApi);

const onTokenInvalidOrExpired = reason => {
  console.warn("XPSession:", reason);
  loginStrategy.login()
};

tokenLoader.loadToken()
  .subscribe(
    loadedToken => sessionManager.setToken(loadedToken),
    error => onTokenInvalidOrExpired(error)
  );

sessionManager.onTokenChanged
  .subscribe(token => tokenStorage.setToken(token));

sessionManager.onTokenExpired
  .subscribe((status) => onTokenInvalidOrExpired(status));

tokenRenewer.onTokenRenewed
  .subscribe(
    newToken => sessionManager.setToken(newToken),
    error => onTokenInvalidOrExpired(error));

window.xpSession = sessionManager;